export const multiselectPreset = {
  root: ({ props, state }: any) => ({
    class: [
      // States
      { '!ring-blue-200/50 dark:!ring-blue-600/50': state.focused },
    ],
  }),
};
